export const cepMask = (e) => {
    const { value } = e.target
    e.target.value = value
        .replace(/\D/g, '')
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{3})\d+?$/, '$1')
}

export const cepMaskValue = (value) => {
    value = value
        .replace(/\D/g, '')
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{3})\d+?$/, '$1')
    
    return value;
}